import React, { useEffect, useState } from "react";
import { Button, Modal, Nav, Spinner, Tab } from "react-bootstrap";
import styles from "./ViewTaskPop.module.css";
import { useSelector } from "react-redux";
import { useLanguage } from "../../../hooks/useLanguage";

const ViewTask = ({ viewTaskPop, setViewTaskPop }) => {
  const t = useLanguage();
  const { taskDetails } = useSelector(({ Tasks }) => Tasks);

  const handleView = () => {
    setViewTaskPop(!viewTaskPop);
  };

  return (
    <>
      <Modal
        show={viewTaskPop}
        onHide={handleView}
        backdrop="true"
        centered
        className={`${styles.ViewPop} bottomPop`}
        keyboard={false}
      >
        <div className="modalWrpper">
          <Modal.Body className="pb-5">
            <Button
              onClick={handleView}
              variant="transparent"
              className="border-0 p-0 position-absolute"
              style={{ top: 15, right: 15 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.0024 26.0048C20.1834 26.0048 26.0048 20.1834 26.0048 13.0024C26.0048 5.82137 20.1834 0 13.0024 0C5.82137 0 0 5.82137 0 13.0024C0 20.1834 5.82137 26.0048 13.0024 26.0048ZM13.0062 14.1485L18.1747 19.3251L19.3205 18.1711L14.152 13.0026L19.3205 7.83412L18.1747 6.68827L13.0062 11.8568L7.83767 6.68015L6.6837 7.83412L11.8603 13.0026L6.6837 18.1711L7.83767 19.3251L13.0062 14.1485Z"
                  fill="#506380"
                />
              </svg>
            </Button>
            <div className="pb-2 pt-5 text-center">
              <img
                src={taskDetails?.icon}
                alt=""
                className="img-fluid object-fit-contain"
                style={{ height: 80 }}
              />
              <h4 className="m-0 fw-bold text-white py-2">
                {taskDetails?.title}
              </h4>
              <p className="m-0 text-white py-2">
                {taskDetails?.description ? taskDetails?.description : "--"}
              </p>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

export default ViewTask;
